import { Col, Row, Form, Input, InputNumber, Select } from 'antd';
import { useContext } from 'react';
import { PageContext } from '../../../lib/context';

const AdditionalFeesForm = () => {
  const { form, _onFinish, handleChange, handleMonthChange, display } =
    useContext(PageContext);
  const { Option } = Select;

  return (
    <Form layout="vertical" form={form} onFinish={_onFinish}>
      <Row gutter={16}>
        <Col span={24}>
          <Form.Item
            label="Title"
            name="title"
            rules={[{ required: true, message: 'Title is required' }]}
          >
            <Input />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col span={24}>
          <Form.Item
            label="Amount"
            name="amount"
            rules={[{ required: true, message: 'Amount is required' }]}
          >
            <InputNumber style={{ width: 350 }} />
          </Form.Item>
        </Col>
      </Row>

      <Row gutter={16}>
        <Col span={12}>
          <Form.Item
            label="Mode of Payment"
            name="mode_of_payment"
            rules={[
              { required: true, message: 'Mode of payment is required.' },
            ]}
          >
            <Select
              style={{ width: 350 }}
              onChange={handleChange}
              placeholder="Select mode of payment"
            >
              <Option value="Straight Payment">Straight Payment</Option>
              <Option value="Installment">Installment</Option>
            </Select>
          </Form.Item>
        </Col>
        <Col span={12}>
          <Form.Item
            label="Number of Months"
            name="number_of_months"
            initialValue="1"
          >
            <Select
              style={{ width: 370 }}
              onChange={handleMonthChange}
              disabled={display}
            >
              <Option value="1">1 Month</Option>
              <Option value="12">12 Months</Option>
              <Option value="24">24 Months</Option>
            </Select>
          </Form.Item>
        </Col>
        <Form.Item name="id" hidden={true}>
          <InputNumber />
        </Form.Item>
      </Row>
    </Form>
  );
};

export default AdditionalFeesForm;
